import $ from 'jQuery';
import Drupal from 'Drupal';
import Stats from '../js/components/stats';

Drupal.behaviors.global = {
  attach: (context) => {
    $(context.body).addClass('document-ready');
  },
};

Drupal.behaviors.signal_search = {
  attach: (context) => {
    if (
      $('.block-views-blockafcea-search-views-block-afcea-search').length > 0
    ) {
      if (
        $('.block-views-blockafcea-search-views-block-afcea-search').parents(
          '.afcea-search',
        ).length == 0
      ) {
        $('.block-views-blockafcea-search-views-block-afcea-search')
          .parent('.field')
          .addClass('afcea-search');
      }
    }
  },
};

Drupal.behaviors.mobileMenu = {
  attach: (context) => {
    // Mobile Menu

    $('.l-header').addClass('absolute');

    $(once('bind-click', '#mobile-menu-btn', context)).each(function(){
      $(this).on('click', function (e) {
        e.preventDefault();

        $(this).toggleClass('active');
        $('.l-header, #mobile-header-bar, .header-elements.mobile').toggleClass(
          'active',
        );

        $('.l-header').removeClass('absolute');
        //$('body').toggleClass("fixed");

        $('body').toggleClass('fixedPosition');

        //hide search box when clicked outside of form area
        $(document).mouseup(function (e) {
          var container = $('.l-header');
          // If the target of the click isn't the container
          if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.find('.l-header__inner').removeClass('active');
            $('#mobile-menu-btn').removeClass('active');
          }
        });
      });
    });


    //var stickyOffset = $('.l-header').offset().top;
    var stickyOffset = $('#mobile-header-bar').outerHeight();

    $(window).scroll(function () {
      var sticky = $('.header-elements.mobile'),
        scroll = $(window).scrollTop();

      //console.log(stickyOffset);

      if (scroll >= stickyOffset + 10) {
        sticky.addClass('fixed');
      } else {
        sticky.removeClass('fixed').addClass('absolute');
      }
    });
  },
};

Drupal.behaviors.searchBar = {
  attach: (context) => {
    $(once('bind-click', '#search-btn', context)).each(function(){
      $(this).on('click', function (e) {
        e.preventDefault();
        //var $this = $(this);
        //$this.toggleClass('active');
        $('#search-wrap, #search-btn').toggleClass('active');
      });
    });

    //hide search box when clicked outside of form area
    $('body').mouseup(function (e) {
      var container = $('.l-header');
      // If the target of the click isn't the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('active');
        $('#search-wrap, #search-btn').removeClass('active');
      }
    });
  },
};

Drupal.behaviors.pauseAnimations = {
  attach: (context) => {
    $('.field--name-field-hero-slides video')
      .delay(2000)
      .queue(function () {
        $(this).addClass('show');
      });

    $('.pause', context).click(function (e) {
      $(this).toggleClass('active');
      if ($(this).hasClass('active')) {
        $(this).html('<i class="fa-solid fa-play"></i> Play');
        $('.field--name-field-hero-slides video').trigger('pause');
      } else {
        $(this).html('<i class="fa-solid fa-pause"></i> Pause');
        $('.field--name-field-hero-slides video').trigger('play');
      }
    });
  },
};

$(document).ready(function () {
  // Select the button
  var btn = document.querySelector('#checkbox-pause'); // Select the preference preference from localStorage
  var animate = localStorage.getItem('animations'); // If the current preference in localStorage is "pause"...
  if (animate == 'pause') {
    // ...then use the .pause-animations class
    document.body.classList.add('pause-animations');
    $('#checkbox-pause').prop('checked', true);
    $('video').trigger('pause');
    $('.pause').addClass('active');
    $('.pause').html('<i class="fa-solid fa-play"></i> Play');
  } // Listen for a click on the button

  if (btn) {
    btn.addEventListener('click', function () {
      // Toggle the .pause-animations class on each click
      document.body.classList.toggle('pause-animations'); // Let's say the preference is equal to animate
      $('.pause').toggleClass('active');
      var preference = 'animate'; // If the body contains the .pause-animations class...
      if (document.body.classList.contains('pause-animations')) {
        // ...then let's make the preference pause
        preference = 'pause';
        document.querySelector('#checkbox-pause').checked = true;
        $('video').trigger('pause');
        $('.pause').html('<i class="fa-solid fa-play"></i> Play');
      } else {
        $('video').trigger('play');
        $('.pause').html('<i class="fa-solid fa-pause"></i> Pause');
      }

      // Then save the choice in localStorage
      localStorage.setItem('animations', preference);
    });
  }
});

//we add the not selector for the specific image slider on the homepage that also shares common classes with a normal quote slider
Drupal.behaviors.quoteSlider = {
  attach: (context) => {
    var slider = $(
      '.paragraph--carousel:not(#paragraph-16) .field--name-field-person-gallery-items',
    ).length;
    if (slider > 0) {
      $(
        '.paragraph--carousel:not(#paragraph-16) .field--name-field-person-gallery-items',
      )
        .not('.slick-initialized')
        .slick({
          slide:
            '.paragraph--carousel .field--name-field-person-gallery-items .field__item',
          dots: false,
          autoplay: false,
          arrows: true,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          prevArrow:
            "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
          nextArrow:
            "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
        });
    }
  },
};

Drupal.behaviors.imageSlider = {
  attach: (context) => {
    var slickEl = $(
      '.paragraph--two-column .field--name-field-person-gallery-items',
    ).length;
    if (slickEl > 0) {
      $('.paragraph--two-column .field--name-field-person-gallery-items')
        .not('.slick-initialized')
        .slick({
          slide:
            '.paragraph--two-column .field--name-field-person-gallery-items .field__item',
          centerMode: true,
          centerPadding: '125px',
          slidesToShow: 1,
          focusOnSelect: true,
          dots: false,
          infinite: true,
          prevArrow:
            "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
          nextArrow:
            "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1,
              },
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1,
              },
            },
          ],
        });
    }
  },
};

Drupal.behaviors.logoSlider = {
  attach: (context) => {
    var logos = $('.logo-row.slider ').length;

    if (logos) {
      $('.logo-row.slider')
        .not('.slick-initialized')
        .slick({
          slide: '.logo-row.slider > .field__item',
          dots: false,
          arrows: true,
          infinite: true,
          slidesToShow: 5,
          slidesToScroll: 1,
          prevArrow:
            "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
          nextArrow:
            "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
          responsive: [
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
    }
  },
};

Drupal.behaviors.linkBar = {
  attach: (context) => {
    $(document).ready(function () {
      var linkbar = $('.paragraph--linkbar').length;
      if (linkbar) {
        var stickyNavTop = $('.paragraph--linkbar').offset().top;
        var stickyNav = function () {
          var scrollTop = $(window).scrollTop();
          if (scrollTop > stickyNavTop) {
            $('.paragraph--linkbar').addClass('sticky');
          } else {
            $('.paragraph--linkbar').removeClass('sticky');
          }
        };
        stickyNav();
        $(window).scroll(function () {
          stickyNav();
        });
      }
    });
  },
};

Drupal.behaviors.tabs = {
  attach: (context) => {
    $('.paragraph--tabs').each(function () {
      var $myTabs = $(this);
      $myTabs.find('.tabs li:first-child').addClass('active-tab');
      var activeIndex = $myTabs.find('.active-tab').index(),
        $contentlis = $myTabs.find('.tabs-content > .field__item'),
        $tabslis = $myTabs.find('.tabs li');
      // Show content of active tab on loads
      $contentlis.eq(activeIndex).addClass('active-tab');

      $myTabs.find('.tabs').on('click', 'li', function (e) {
        var $current = $(e.currentTarget),
          index = $current.index();
        $tabslis.removeClass('active-tab');
        $current.addClass('active-tab');
        $contentlis.removeClass('active-tab').eq(index).addClass('active-tab');
      });
    });
  },
};

Drupal.behaviors.afcea_impact_stats = {
  attach: (context) => {
    context
      .querySelectorAll(
        '.paragraph--impact-stats-3-column .field--name-field-stat-number',
      )
      .forEach((element) => {
        if (!element.Stats) {
          element.Stats = new Stats(element);
        }
      });
  },
};

Drupal.behaviors.youtube_player = {
  // Expand 'Secondary' media-embed videos to full-width on click.
  attach: (context) => {
    $(function () {
      // Select each secondary media embed.
      context
        .querySelectorAll(
          '.paragraph--selected-videos .field--name-field-secondary-external-video .field__item',
        )
        .forEach((element) => {
          // On-click, hide the content and expand the video.
          element.addEventListener('click', function () {
            let leftColumn = this.querySelector('.column.column__left');
            let rightColumn = this.querySelector('.column.column__right');

            leftColumn.style.width = '100%';
            rightColumn.style.display = 'none';
          });
        });
    });
  },
};

Drupal.behaviors.afcea_cookie_compliance = {
  attach: (context) => {
    $('html').on('eu_cookie_compliance_popup_open', function () {
      $('button.eu-cookie-compliance--alt-close-button').click(function () {
        $('#sliding-popup')
          .trigger('eu_cookie_compliance_popup_close')
          .remove();
      });
    });
  },
};
Drupal.behaviors.featureArticlesView = {
  attach: (context) => {
    var slider = $(
      '.paragraph--featured-article-view-slider .view-content',
    ).length;
    if (slider > 0) {
      $('.paragraph--featured-article-view-slider .view-content')
        .not('.slick-initialized')
        .slick({
          centerMode: true,
          centerPadding: '15%',
          slidesToShow: 1,
          slidesToScroll: 1,
          focusOnSelect: true,
          prevArrow:
            "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
          nextArrow:
            "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
          responsive: [
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 650,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                centerPadding: '0',
              },
            },
            {
              breakpoint: 480,
              settings: {
                centerMode: false,
                slidesToShow: 1,
                slidesToScrol1: 1,
                centerPadding: '0',
              },
            },
          ],
        });
    }
  },
};

Drupal.behaviors.alertBar = {
  attach: (context) => {
    var reportWindowSize = function(){

      var notificationH = $('.l-pre-header #block-sitewidealert').height();
      $('.page-node-type-homepage .node__content > .field--name-field-hero-slides').css('padding-top',notificationH);
    }

    $(document, context).ajaxComplete(function () {
      if ($('.sitewide-alert').length) {
        $('body').addClass('alert-bar');
        var notificationH = $('.l-pre-header #block-sitewidealert').height();
        $('.page-node-type-homepage .node__content > .field--name-field-hero-slides').css('padding-top',notificationH);

        $('.js-dismiss-button').click(function () {
          $('body').removeClass('alert-bar');
          $('.page-node-type-homepage .node__content > .field--name-field-hero-slides').css('padding-top',0);
        });
      }
    });
    window.addEventListener('resize', reportWindowSize);


    $('.js-dismiss-button').click(function () {

      $('body').removeClass('alert-bar');
      $('.page-node-type-homepage .node__content > .field--name-field-hero-slides').css('padding-top',0);
    });
  },
};

Drupal.behaviors.event_search = {
  attach: (context) => {
    if ($('.view-afcea-event-search .dates-wrapper').length == 0) {
      $('.form-item-start, .form-item-end').wrapAll(
        '<div class="dates-wrapper js-form-item form-item js-form-type-textfield form-type-textfield "/>',
      );
    }

    if ($('.view-afcea-event-search .options-wrapper').length == 0) {
      $('.view-afcea-event-search form')
        .find('fieldset, details, .form-actions')
        .wrapAll('<div class="options-wrapper js-form-item form-item "/>');
    }

    if ($('.node--landing-page.node-page-events').length == 0) {
      $('.node--landing-page').addClass('node-page-events');

      // Update Event Search hero.
      $(document).ready(function () {
        var slider = $('.view-hero-featured-events .view-content').length;
        //console.log($('.view-hero-featured-events .view-content'));
        if (slider > 0) {
          $('.view-hero-featured-events .view-content')
            .not('.slick-initialized')
            .slick({
              slide: '.view-hero-featured-events .view-content .views-row',
              dots: false,
              autoplay: false,
              arrows: true,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              prevArrow:
                "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
              nextArrow:
                "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
            });
        }
      });
    }
  },
};

Drupal.behaviors.relatedArticlesSlider = {
  attach: (context) => {
    var slider = $(
      '.paragraph--related-articles-slider .related-articles-slider .view-content',
    ).length;
    if (slider > 0) {
      $(
        '.paragraph--related-articles-slider .related-articles-slider .view-content',
      )
        .not('.slick-initialized')
        .slick({
          slide:
            '.paragraph--related-articles-slider .related-articles-slider .view-content .views-row',
          dots: false,
          autoplay: false,
          arrows: true,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow:
            "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
          nextArrow:
            "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
        });
    }

    // Mobile.
    var mobile_slider = $(
      '.paragraph--related-articles-slider .related-articles-mobile .view-content',
    ).length;
    if (mobile_slider > 0) {
      $(
        '.paragraph--related-articles-slider .related-articles-mobile .view-content',
      )
        .not('.slick-initialized')
        .slick({
          slide:
            '.paragraph--related-articles-slider .related-articles-mobile .view-content .views-row',
          dots: false,
          autoplay: false,
          arrows: true,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow:
            "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
          nextArrow:
            "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
        });
    }
  },
};

Drupal.behaviors.wysiwig = {
  attach: (context) => {
    $('.paragraph--wysiwyg p').each(function () {
      if ($(this).text().trim().length <= 0 && $(this).children().length <= 0) {
        $(this).remove();
      }
    });
    $(document).ready(function () {
      document.querySelectorAll('.paragraph--wysiwyg table',context).forEach(el => {
        if ($(el).find('tbody').width() > document.documentElement.offsetWidth) {
          $(el).addClass('scroll-notification')
        }
        $(window).resize(function() {
          var width = $(window).width();
          var height = $(window).height();
          if ($(el).find('tbody')[0].offsetWidth > document.documentElement.offsetWidth) {
            $(el).addClass('scroll-notification')
          }else{
            $(el).removeClass('scroll-notification')
          }
        })

      });
    })
  },
};

Drupal.behaviors.flyingad = {
  attach: (context) => {
    $(document).ready(function () {
      if (document.cookie.indexOf('popclosedside=true') >= 0) {
        //Do Nothing -- you've closed the side popup in this session
      } else {
        const ad = document.getElementById('flyoutad');
        if (ad) {
          ad.style.right = '0';
          setTimeout(function () {
            hideflyoutclose();
          }, 12000);
        }
      }
      function hideflyoutclose() {
        const ad = document.getElementById('flyoutad');
        if (ad) {
          ad.style.display = 'none';
        }
        return false;
      }
      function hideflyoutcloseclick() {
        const ad = document.getElementById('flyoutad');
        if (ad) {
          ad.style.display = 'none';
        }
        document.cookie = 'popclosedside=true;';
        return false;
      }
    });
  },
};
